import React from "react";
// Limitless imports
import { useNotificationContext, useTranslation } from "@limitless/common/hooks";
import { useExpertOnboardingContext } from "./ExpertOnboardingContext";
import { useExpertOnboardingContentHook } from "./ExpertOnboardingContentHook";
const INITIAL_STATE = {
  template: null,
  sections: [],
  loading: true
};
export const useExpertOnboardingOptInContentHook = () => {
  const {
    optInGroup
  } = useExpertOnboardingContext();
  const {
    fetchExpertOnboardingContent,
    findContentResource
  } = useExpertOnboardingContentHook();
  const [onboardingOptInContent, setOnboardingOptInContent] = React.useState(INITIAL_STATE);
  const {
    addFailureNotification
  } = useNotificationContext();
  const {
    t
  } = useTranslation();
  React.useEffect(() => {
    if (optInGroup) {
      // const practiceGroup = groups.find(item => item.membershipState === "invited") ?? groups[0];
      setOnboardingOptInContent({
        ...INITIAL_STATE,
        loading: true
      });
      fetchExpertOnboardingContent("onboardingOptIn.json", optInGroup, (template, sections) => {
        sectionFormation("onboardingOptIn.json", {
          sections
        }, response => {
          const {
            sections = []
          } = response;
          setOnboardingOptInContent({
            ...INITIAL_STATE,
            loading: false,
            template,
            sections
          });
        });
      }, () => {
        setOnboardingOptInContent(INITIAL_STATE);
        addFailureNotification(t("Onboarding opt-in page contents missing, please contact Limitless support."));
      });
    }
  }, [optInGroup]);
  const sectionFormation = (fileName, section, callback) => {
    const sectionsToString = JSON.stringify(section);
    const isFound = sectionsToString === null || sectionsToString === void 0 ? void 0 : sectionsToString.search("{{target_group_adjusted_fee}}");
    if (isFound !== -1) {
      findContentResource(fileName, optInGroup, response => {
        callback(response);
      }, () => {
        callback(section);
      });
    } else {
      callback(section);
    }
  };
  return {
    onboardingOptInContent,
    optInGroup,
    sectionFormation
  };
};